import router from "../router";
import promokit from '@/utils/promokit';

const routerControll = (arrow = 'next') => {
  const routes = router.options.routes;
  let num, currentRoute, nextRoute, obj;
  currentRoute = router.currentRoute.name ? router.currentRoute.name : 'index';
  if (currentRoute == 'clip') {
    // obj = {query:{page:0}};
    let page = router.currentRoute.query.page;
    if (arrow == 'next') page++;
    if (arrow == 'prev') page--;
    if (1 <= page && page <= 5) {
      obj = { page: page };
      router.push({ name: currentRoute, query: obj });
      return
    } else {
    };
  }

  for (let i = 0; i < routes.length; i++) {
    if (routes[i].name === currentRoute) {
      num = i;
      break;
    }
  }


  if (arrow == 'next') num++;
  if (arrow == 'prev') num--;
  if (num < 0 || num >= routes.length - 1) return;
  nextRoute = routes[num].name;

  if (currentRoute == 'paradigm') {
    obj = { page: 1 };
  }

  if (currentRoute == 'purple') {
    if (nextRoute == 'clip') {
      // if(promokit.util.isMobile()){
      //  obj = {page:5};
      //}else{
      obj = { page: 1 };
      //}
    }


  }

  // if(nextRoute == 'index')nextRoute = '/';
  router.push({ name: nextRoute, query: obj });
};

export default routerControll;
